import React from 'react';
import { TypographyH3 } from '@/Components/shadcn/typography';

export interface JobAdLabelProps {
    label: string;
}

function JobAdLabel({ label }: JobAdLabelProps): React.JSX.Element {
    return <TypographyH3 className="text-foreground font-bold">{label}</TypographyH3>;
}

export default JobAdLabel;
